import { FrameCorners } from '@phosphor-icons/react';

export default FrameCorners;
